import AddToCartPopUpComponent from 'Component/AddToCartPopUp';
import {
    AddToCart as SourceAddToCart
} from 'SourceComponent/AddToCart/AddToCart.component';

/** @namespace Bodypwa/Component/AddToCart/Component */
export class AddToCartComponent extends SourceAddToCart {
    render() {
        const {
            mix,
            addProductToCart,
            layout,
            isDisabled,
            isAdding,
            porductBeingAdded
        } = this.props;

        return (
            <>
            <AddToCartPopUpComponent product={ porductBeingAdded } />
            <button
              onClick={ addProductToCart }
              block="Button AddToCart"
              mix={ mix }
              mods={ { layout } }
              disabled={ isDisabled || isAdding }
            >
                { this.renderCartIcon() }
                <span>
                    <span style={ { display: isAdding ? 'none' : '' } }>{ __('Add to cart') }</span>
                    <span style={ { display: !isAdding ? 'none' : '' } }>{ __('Adding...') }</span>
                </span>
            </button>
            </>
        );
    }
}

export default AddToCartComponent;
